export default "__VITE_ASSET__CWMWA_5b__"